import { X } from 'lucide-react';
import { type ReactNode } from 'react';

export function ReferenceChipTray({
    testId,
    children,
}: {
    readonly testId: string;
    readonly children: ReactNode;
}) {
    return (
        <div
            data-testid={testId}
            className="border-border bg-background mb-2 rounded-xl border p-1"
        >
            {children}
        </div>
    );
}

export function ReferenceRemoveButton({
    label,
    testId,
    onClick,
}: {
    readonly label: string;
    readonly testId: string;
    readonly onClick: () => void;
}) {
    return (
        <button
            type="button"
            aria-label={label}
            data-testid={testId}
            className="text-muted-foreground hover:text-foreground flex h-5 w-5 shrink-0 items-center justify-center rounded"
            onClick={onClick}
        >
            <X className="h-3.5 w-3.5" />
        </button>
    );
}

export function ReferenceChip({
    leading,
    children,
    removeLabel,
    removeTestId,
    rowTestId,
    onRemove,
}: {
    readonly leading?: ReactNode;
    readonly children: ReactNode;
    readonly removeLabel: string;
    readonly removeTestId: string;
    readonly rowTestId: string;
    readonly onRemove: () => void;
}) {
    return (
        <div
            data-testid={rowTestId}
            className="hover:bg-muted/60 flex items-center gap-2 rounded-lg px-1.5 py-1"
        >
            {leading}
            {children}
            <ReferenceRemoveButton
                label={removeLabel}
                testId={removeTestId}
                onClick={onRemove}
            />
        </div>
    );
}
